import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-loyalty-promocode-configuration-smart',
  template: `<app-loyalty-promocode-configuration [countries]="countries" [codeGroups]="codeGroups" [loyaltyPromotionsData]="loyaltyPromotions" [tiers]="tiers"></app-loyalty-promocode-configuration>`,
  styles: [
  ]
})
export class LoyaltyPromocodeSmartComponent extends FeaturesBaseComponent implements OnInit {
  loyaltyPromotions: any[];
  codeGroups: any[] = [];
  countries: any[] = [];
  tiers: any[] = [];
  constructor(private promotionService: PromotionsService) {
    super();
    this.getLoyaltyPromoData()
  }
  getLoyaltyPromoData() {
    //Get list of countries
    this.promotionService.getCarrierCountries()
      .subscribe(arg => this.countries = arg['data']);


    this.promotionService.getAllLoyaltyPromotions().subscribe(
      (res) => this.loyaltyPromotions = (res['data'])
    )


    //Get list of code groups

    this.promotionService.getcodeGroups().subscribe(
      res => this.codeGroups = res['data']
    )

    //Get list of Tiers

    this.promotionService.getTiers().subscribe(
      res => this.tiers = res['data']
    )

  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

}
